import api from './api';
import { hydrateSettingsFromUser } from './settings';

const CACHE_KEY = 'userInfo';
const CACHE_TTL = 5 * 60 * 1000; // 5 minutes

/**
 * The current user (cached for CACHE_TTL). Resolves null when it can't be loaded; with
 * { throwErrors: true } a failure other than 401 (5xx, timeout, network) is thrown instead, so
 * the caller can tell "not logged in" from "server trouble". On 401, api.js has already logged
 * out and is redirecting to /login, and this resolves null.
 */
export async function getUserInfo(forceRefresh = false, { throwErrors = false } = {}) {
  try {
    // Try to get from sessionStorage
    if (!forceRefresh) {
      const cached = sessionStorage.getItem(CACHE_KEY);
      if (cached) {
        const { data, ts } = JSON.parse(cached);
        if (Date.now() - ts < CACHE_TTL) {
          return data;
        }
      }
    }
    // Fetch from API
    const response = await api.post('/me', {});
    // api.js resolves (not rejects) a 401 with no response, after logging out
    if (!response) return null;
    const data = response.data;
    // Store token_id if present
    if (data.token_id) {
      localStorage.setItem('token_id', String(data.token_id));
    }
    // Store in sessionStorage with timestamp
  sessionStorage.setItem(CACHE_KEY, JSON.stringify({ data, ts: Date.now() }));
  hydrateSettingsFromUser(data);
  return data;
  } catch (e) {
    if (throwErrors) throw e;
    return null;
  }
}

// API session handling
export async function getSessions() {
  try {
    const response = await api.post('/me/sessions');    
    return response.data;
  } catch (e) {    
    return [];
  }
}

export async function cleanOtherSessions() {
  try {
    await api.post('/me/clean-sessions');
    return true;
  } catch (e) {
    return false;
  }
}

export async function removeSession(tokenId) {
  try {
    await api.delete(`/me/sessions/${tokenId}`);
    return true;
  } catch (e) {
    return false;
  }
}


